import JassEnum from './enum';

/**
 * type startlocprio
 */
export default class JassStartLocPrio extends JassEnum {}
